var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"e-status-badge",class:_vm.size,attrs:{"variant":_vm.variant,"pill":_vm.pill}},[_c('i',{staticClass:"fas fa-fw mr-1",class:_vm.glyphComputed}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }